function LoginModal({ onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
        >
          &times;
        </button>
        <h2 className="text-lg font-semibold mb-2">Login Required</h2>
        <p className="text-sm text-gray-600 mb-4">
          You must be logged in to perform this action.
        </p>
        <button
          onClick={() => {
            onClose();
            window.location.href = "/login"; // or use navigate from react-router
          }}
          className="peer-home-btn-primary px-4 py-2 text-sm"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}

export default LoginModal;
